import { createAction, props } from '@ngrx/store';
import { APIError } from '../../shared/interfaces/api-error.interface';
import { AuthPayload } from '../interfaces/auth-payload.interface';
import { AuthResponse } from '../interfaces/auth-response.interface';

export const loginUserRequest = createAction(
  '[Auth] Login User Request',
  props<{ payload: AuthPayload }>()
);

export const loginUserSuccess = createAction(
  '[Auth] Login User Success',
  props<{ response: AuthResponse }>()
);

export const loginUserFailure = createAction(
  '[Auth] Login User Failure',
  props<{ response: APIError }>()
);

export const authActionTypes = {
  loginUserRequest,
  loginUserSuccess,
  loginUserFailure,
};
